"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListProfile = ListProfile;
var react_1 = __importDefault(require("react"));
var ListContent_1 = require("../ListContent");
//we destructure only to make this comp easy to use for developers
function ListProfile(_a) {
    var id = _a.id, data = _a.data, config = _a.config, to = _a.to, onClick = _a.onClick, openInNewTab = _a.openInNewTab, actions = _a.actions;
    var props = arguments[0];
    return (react_1.default.createElement(ListContent_1.ListContent, __assign({}, props, { variant: 'profile' })));
}
;
